import React from "react";
import back from '../image/back.png';

const TDSandTSC = () => {
  const handleAppointmentClick = () => {
    window.open(
      "http://topmate.io/sanjay_nathani/?utm_source=topmate&utm_medium=popup&utm_campaign=Page_Ready",
      "_blank"
    );
  };
  return (

    <>
      <div className="bg-white rounded-lg">
        {/* Background Section */}
        <div
          className="bg-cover h-64 flex flex-col justify-center items-center text-center"
          style={{
            backgroundImage: `url(${back})`,
          }}
        >
          <h1 className="text-2xl md:text-3xl font-bold text-blue-700">
            TDS & TCS Return Filing
          </h1>
          <p className="mt-2 text-black font-semibold text-lg md:text-2xl px-4 md:px-0">
            Hassle-Free TDS & TCS Returns Filing Services with Sanjay K Nathani & Co.
          </p>
        </div>

        {/* Description Section */}
        <div className="px-6 py-10 md:px-20 lg:px-40">
          <p className="text-gray-700 leading-relaxed mb-6 text-sm md:text-base">
          At Sanjay K Nathani & Co., we understand that filing TDS and TCS returns can be a challenging and time-consuming task for businesses. That’s why we offer TDS and TCS returns filing services to help businesses comply with the tax deduction and collection regulations and avoid penalties.          </p>
          <p className="text-gray-700 leading-relaxed mb-6 text-sm md:text-base">
            We proactively support your TDS and TCS compliance by assisting with all aspects of return filing, including preparation, filing, data reconciliation, and addressing any queries from tax authorities.
          </p>
          

          {/* List of Services */}
          <ol className="list-disc list-inside space-y-2 text-gray-700 text-sm md:text-base">
            <li>Preparation and filing of monthly, quarterly, and annual TDS and TCS returns</li>
            <li>Reconciliation of TDS and TCS data to ensure accuracy and completeness</li>
            <li>Compliance with tax deduction and collection regulations and requirements</li>
            <li>Filing of TDS and TCS refunds, if applicable</li>
            <li>Assistance with TDS and TCS audits and assessments</li>
          </ol>
        </div>

        {/* Contact Section */}
        <div className="mt-8 bg-gray-50 p-6 rounded-lg shadow-sm mx-4 md:mx-20 lg:mx-40">
          <h2 className="text-lg md:text-xl font-bold text-gray-800 mb-4">Get in touch</h2>
          <p className="text-gray-600 mb-6 text-sm md:text-base">
            If you have any queries or questions, please reach out to us by clicking on the contact button and filling out the form.
          </p>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            {/* Make Appointment Button */}
            <button onClick={handleAppointmentClick}  className="px-6 py-2 bg-orange-500 text-white rounded hover:bg-orange-600 transition duration-200 w-full sm:w-auto">
              Make Appointment
            </button>

            {/* Contact Us Button */}
            <button className="px-6 py-2 bg-[#005A8C] text-white rounded  transition duration-200 w-full sm:w-auto">
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default TDSandTSC;